import React from 'react'
import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import { ControlledHiddenInput, ControlledTextArea } from 'transfix-form/components'
import { TAs2CertificateModalSchema } from '../schema/As2CertificateModalSchema'
import { useAs2CertificateModalFormContext } from './useAs2CertificateModalForm'

const getErrorMessage = <T extends FieldErrors<TAs2CertificateModalSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export const As2CertificateModalForm = () => {
  const { control, errors } = useAs2CertificateModalFormContext()

  return (
    <form data-test='As2CertificateModalForm'>
      <ControlledHiddenInput name='id' control={control} />
      <ControlledTextArea
        name='body'
        control={control}
        TextAreaProps={{
          required: true,
          label: 'Certificate Body',
          invalid: !!getErrorMessage(errors, 'body'),
          placeholder: 'Enter the body of certificate',
          dataTest: 'input-certificate-body',
        }}
      />
    </form>
  )
}
